<!-- V2 Inline Content Editor - Seamless Form Integration -->
<div class="v2-content-editor" [attr.data-section]="sectionTheme">
  
  <!-- Original Content Reference (at top, collapsed by default) -->
  <details class="original-content-reference">
    <summary class="reference-toggle">View Original Content</summary>
    <div class="original-content">
      <div class="original-content-display">{{ originalContent || 'No original content' }}</div>
    </div>
  </details>

  <!-- Content Editing Field -->
  <div class="form-group">
    <label class="field-label" [for]="'content-' + editRequest?.tagName">{{ getContentLabel() }}</label>
    <div class="textarea-wrapper">
      <textarea 
        [id]="'content-' + editRequest?.tagName"
        #contentTextarea
        [(ngModel)]="newContent"
        (input)="onContentChange()"
        placeholder="Enter your content here..."
        rows="6"
        class="form-control content-textarea"
        [class.modified]="newContent !== originalContent"
        (focus)="onContentFocus()"
        (click)="onContentClick($event)">
      </textarea>
      <div class="character-count">{{ newContent.length }} characters</div>
    </div>
  </div>

  <!-- AI Content Accept/Reject Buttons (shown after regeneration) -->
  <div class="ai-content-actions" *ngIf="showAcceptReject">
    <div class="ai-content-notice">
      <span class="notice-text">OTTO has generated new content. Review and choose:</span>
    </div>
    <div class="action-buttons">
      <button 
        type="button" 
        class="btn btn-outline reject-btn" 
        (click)="rejectGeneratedContent()">
        Keep Original
      </button>
      <button 
        type="button" 
        class="btn btn-primary accept-btn" 
        (click)="acceptGeneratedContent()">
        Use New Content
      </button>
    </div>
  </div>

  <!-- AI Feedback Field (for regeneration) -->
  <div class="form-group" (click)="$event.stopPropagation()">
    <label class="field-label" [for]="'feedback-' + editRequest?.tagName">Improve with AI</label>
    <div class="textarea-wrapper">
      <textarea 
        [id]="'feedback-' + editRequest?.tagName"
        #feedbackTextarea
        [(ngModel)]="userFeedback"
        [placeholder]="getFeedbackPlaceholder()"
        rows="3"
        class="form-control feedback-textarea"
        (click)="onFeedbackClick($event)"
        (focus)="onFeedbackFocus()"
        (mousedown)="$event.stopPropagation()">
      </textarea>
      <button 
        type="button"
        class="btn btn-secondary regenerate-btn"
        [disabled]="!userFeedback.trim() || isGenerating"
        (click)="regenerateContent()">
        <span class="btn-icon sparkle-icon">
          <span class="sparkle-triangle"></span>
          <span class="sparkle-triangle"></span>
        </span>
        <span *ngIf="!isGenerating">Regenerate Content</span>
        <span *ngIf="isGenerating">Generating...</span>
      </button>
    </div>
  </div>

  <!-- Save/Cancel Actions -->
  <div class="editor-actions">
    <button 
      type="button" 
      class="btn btn-outline cancel-btn" 
      (click)="cancelEdit()">
      Cancel
    </button>
    <button 
      type="button" 
      class="btn btn-primary save-btn" 
      [disabled]="!newContent.trim()"
      (click)="saveContent()">
      Update
    </button>
  </div>

</div> 